export default __webpack_public_path__ + "static/email-templates-change-recipient-58d8a20d2a232688948225e3571cdd52.mp4";